/** Lets a page take over the header back control while it's on an inner
 *  step (e.g. the auth page's email and code steps go back to the choice
 *  before them, the same as their in-page Back), instead of leaving the page. */
import { createContext, useContext, useEffect, type MutableRefObject } from 'react';

export const BackOverrideContext = createContext<MutableRefObject<(() => void) | null> | null>(null);

export function useBackOverride(handler: (() => void) | null): void {
  const ref = useContext(BackOverrideContext);
  useEffect(() => {
    if (!ref) return;
    ref.current = handler;
    return () => { if (ref.current === handler) ref.current = null; };
  }, [ref, handler]);
}
